import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { Alert, Button, Card, CardContent, CardHeader, Collapse, IconButton, Typography } from "@mui/material";
import { child, get, getDatabase, ref } from "firebase/database";
import React, { ReactElement } from "react";

import FirebaseApp from "../FirebaseInit";
import GetCookie from "../Functions/GetCookie";
import GameObject from "../Types/GameObject";

export default function GameViewer() {
    const [gameInfo, gameInfoSet] = React.useState({
        name: "Loading...", description: "Loading", game: <Typography variant="h4" fontWeight="bold" color="white">Loading</Typography>
    });
    const [run, runSet] = React.useState<boolean>(true);
    const [flashGameAlert, flashGameAlertSet] = React.useState<boolean>(false);
    let gameCodename = window.location.pathname.replace("/game/", "");

    let OnFlashAlertClose = () => {
        flashGameAlertSet(false);
        document.cookie = "flashGameAlertNoShow=true; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
    }
    function exitHandler() {
        if (!document.fullscreenElement) {
            document.getElementById("gameFrame")?.classList.add("bradius10px");
        }
    }
    let onFullscreenClick = () => {
        document.getElementById("gameFrame")?.requestFullscreen();
        document.addEventListener("fullscreenchange", exitHandler, false);
        document.getElementById("gameFrame")?.classList.remove("bradius10px");
    }

    if (run) {
        runSet(false);
        const database = ref(getDatabase(FirebaseApp));

        get(child(database, `/favoritesMetadata/${gameCodename}`)).then((snapshot) => {
            if (snapshot.exists()) {
                let game: GameObject = snapshot.val();
                let gameFrame: ReactElement = <h1>Loading</h1>;
                switch (game.type) {
                    case "flash":
                        if (!GetCookie("flashGameAlertNoShow")) {
                            flashGameAlertSet(true);
                        }
                        // load best flash em for game
                        switch (game.flplayer) {
                            case "ruffle":
                                gameFrame = <embed id="gameFrame" title={game.fullName} src={game.url} style={{ height: "100vh", width: "100%" }} />;
                                break;
                            case "awayfl":
                                // better for some games
                                gameFrame = <iframe id="gameFrame" title={game.fullName} src={`https://wakestudents.github.io/static/html/awayFL/index.html?swf=${game.url}`} allowFullScreen frameBorder="0" style={{ height: "100vh", width: "100%", overflowY: "hidden" }} className="bradius10px"></iframe>
                                break;
                            case "swf2jsprod":
                                // better for as3
                                gameFrame = <iframe id="gameFrame" title={game.fullName} src={`https://wakestudents.github.io/static/html/SWF2JSProd/index.html?swf=${game.url}`} allowFullScreen frameBorder="0" style={{ height: "100vh", width: "100%", overflowY: "hidden" }} className="bradius10px"></iframe>
                                break;
                            case "waflash":
                                gameFrame = <iframe id="gameFrame" title={game.fullName} src={`https://wakestudents.github.io/static/html/waflash/index.html?swf=${game.url}`} allowFullScreen frameBorder="0" style={{ height: "100vh", width: "100%", overflowY: "hidden" }} className="bradius10px"></iframe>
                                break;
                            default:
                                // default to ruffle
                                gameFrame = <embed id="gameFrame" title={game.fullName} src={game.url} style={{ height: "100vh", width: "100%" }} />;
                                break;
                        }
                        break;
                    case "html":
                        gameFrame = <iframe id="gameFrame" title={game.fullName} src={game.url} allowFullScreen frameBorder="0" style={{ height: "100vh", width: "100%", overflowY: "hidden" }} className="bradius10px"></iframe>;
                        break;
                    default:
                        break;
                }
                document.title = `${game.fullName} | Wake Students`;
                gameInfoSet({ name: game.fullName, description: game.description, game: gameFrame });
                document.getElementById("fullscreenEnable")?.classList.remove("d-none");
                if (game.type === "flash" && !GetCookie("flashGameAlertNoShow")) {
                    flashGameAlertSet(true);
                }
            } else {
                console.log("No data available");
                gameInfoSet({
                    name: "Game Not Found", description: "Error has occured.", game: (
                        <Card>
                            <CardContent>
                                <ErrorIcon fontSize="large" />
                                <Typography variant="h4" fontWeight="bold">Game not Found</Typography>
                                <Typography>Game not found. Likely the URL was typed wrong.</Typography>
                                <div style={{ marginTop: ".5rem" }}>
                                    <Button variant="outlined" style={{ marginRight: ".5rem" }} onClick={() => { window.location.reload(); }}>Reload</Button>
                                    <Button variant="contained" onClick={() => { window.history.back(); }}>Go Back</Button>
                                </div>
                            </CardContent>
                        </Card>
                    )
                });
                // throw new Error("Game not found. Likely URL typed wrong.")
            }

        }).catch((error) => {
            console.error(error);
            // errorDialog("Loading Game issue", error);

        });
    }
    return (
        <>
            <Card><CardHeader title={gameInfo.name} action={<Button id="fullscreenEnable" className="d-none" style={{ marginTop: "2px" }} onClick={onFullscreenClick} variant="text" startIcon={<FullscreenIcon />}>Fullscreen</Button>} /></Card>

            <Collapse in={flashGameAlert}>
                <Alert severity="info" style={{ marginTop: "1rem" }} action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={OnFlashAlertClose}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }>
                    Flash game support is in beta. It may not work as expected.
                </Alert>
            </Collapse>


            <div
                style={{ textAlign: "center", marginTop: "24px" }}
            >
                {gameInfo.game}
            </div>
        </>
    )
}